/**
 * SEO & Structured Schema Helper for Novatek
 */
window.SEOHelper = {
  updatePageMeta: function(title, description, canonicalUrl) {
    if (title) {
      document.title = title.includes('Novatek') ? title : `${title} | NOVATEK`;
    }
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement('meta');
        metaDesc.name = 'description';
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute('content', description);
    }
  },

  injectSchema: function(id, schemaObject) {
    let existingScript = document.getElementById(id);
    if (!existingScript) {
      existingScript = document.createElement('script');
      existingScript.id = id;
      existingScript.type = 'application/ld+json';
      document.head.appendChild(existingScript);
    }
    existingScript.textContent = JSON.stringify(schemaObject);
  },

  injectOrganizationSchema: function() {
    this.injectSchema('schema-org', {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "NOVATEK Industrial Systems",
      "alternateName": "NOVATEK Custom Test & Automation Systems",
      "url": "https://www.novatek.co.in",
      "logo": "https://www.novatek.co.in/logo.png",
      "description": "Novatek designs and manufactures custom test rigs, automated test benches and industrial automation systems for Railway, Automotive, Aerospace and Advanced Manufacturing.",
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "NOVATEK Engineering Complex, #20/2G, Anumepalli, Sipcot 1",
        "addressLocality": "Hosur",
        "addressRegion": "Tamil Nadu",
        "postalCode": "635126",
        "addressCountry": "IN"
      },
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "+91-9597730787",
        "contactType": "Technical Sales & Engineering Inquiries",
        "email": "info@novatek.co.in",
        "areaServed": ["IN", "Worldwide"],
        "availableLanguage": ["English", "Hindi", "Tamil"]
      },
      "sameAs": [
        "https://www.linkedin.com/company/novatek-industrial"
      ]
    });
  },

  injectProductSchema: function(product) {
    if (!product) return;
    this.injectSchema('schema-product', {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": product.title,
      "description": product.shortDesc || product.description,
      "brand": {
        "@type": "Brand",
        "name": "NOVATEK"
      },
      "manufacturer": {
        "@type": "Organization",
        "name": "NOVATEK Industrial Systems"
      },
      "category": product.category,
      "offers": {
        "@type": "Offer",
        "priceCurrency": "INR",
        "availability": "https://schema.org/InStock",
        "itemCondition": "https://schema.org/NewCondition",
        "priceSpecification": {
          "@type": "PriceSpecification",
          "description": "Custom engineered to client specifications. Request an engineering consultation for RFQ."
        }
      }
    });
  },

  injectFAQSchema: function(faqs) {
    if (!faqs || faqs.length === 0) return;
    this.injectSchema('schema-faq', {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": faqs.map(faq => ({
        "@type": "Question",
        "name": faq.question,
        "acceptedAnswer": {
          "@type": "Answer",
          "text": faq.answer
        }
      }))
    });
  },

  injectBreadcrumbSchema: function(items) {
    if (!items || items.length === 0) return;
    this.injectSchema('schema-breadcrumb', {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": items.map((item, index) => ({
        "@type": "ListItem",
        "position": index + 1,
        "name": item.name,
        "item": item.url || window.location.origin
      }))
    });
  }
};

// Automatically inject global Organization schema on script load
try {
  window.SEOHelper.injectOrganizationSchema();
} catch (e) {
  console.warn('Schema init warning:', e);
}
